import React from 'react'
import * as S from './styles'

const Cell = ({ filled, filledColor }: { filled: boolean, filledColor: string }) => {
  return <S.Cell css={{ backgroundColor: filled ? filledColor : '$neutralLightest' }} />
}

const ProgressBar: React.FC<{
  title: string
  fill: number
  lastStep?: string
}> = ({
  title,
  fill,
  lastStep
}) => {
    const filledColor = lastStep ? '$successMedium' : '$primaryMedium'
    return (
      <S.ProgressBar>
        <S.Top>
          <span>{title}</span>
          {
            !!lastStep ? <S.Current>{lastStep}</S.Current> : <div><S.Current>{fill}</S.Current>/ 4</div>
          }
        </S.Top>
        <S.Cells>
          <Cell filledColor={filledColor} filled={fill >= 1} />
          <Cell filledColor={filledColor} filled={fill >= 2} />
          <Cell filledColor={filledColor} filled={fill >= 3} />
          <Cell filledColor={filledColor} filled={fill >= 4} />
        </S.Cells>
      </S.ProgressBar>
    )
  }

export default ProgressBar
